export class Key{
    appId : string = "";
    keyId : string = "";
    keyFr : string = "";
    keyNl : string = "";
    keyX : string = "";
  }

  export class Translation
  {
      constructor()
      {
          this.keys = new Array<Key>();
      }
  
      keys: Array<Key>;
  }